import React, { useEffect, useState } from "react";
import { Button, Form, FormControl, Spinner } from "react-bootstrap";
import { pathDemandSubPay } from "../../../common/config/vars";
import { Plus, Trash } from "react-bootstrap-icons";
import { IDem } from "../logics/types";
import { empty, validatePhoneRU, kopecks2rubStr, date2str } from "../../../common/functions";
import { $contractorDems, queryNewOrder, endWordOfBasketTitle} from "../logics/contractorDemands";
import { IContractorService } from "../logics/types";
import { $desireIntervals, queryDesireIntervals } from "../logics/desireIntervals";
import { toast } from "react-toastify";
import { ServiceCounter } from "../../../common/ui/ServiceCounter";
import "../styles/ServicesBasket.css";
import { useStore } from "effector-react";
import { useHistory } from "react-router-dom";
import { $SiteColors } from "../../../common/config/company-atts";
import { getPhone, getSession, getUuid } from "../../../common/localStorage";
import { $user } from "../../../common/user";

interface IShowFreeDemand {
  setServiceIDsInBasket2: React.Dispatch<React.SetStateAction<object>>; //заявка
  setShowBasket: React.Dispatch<React.SetStateAction<boolean>>; //заявка
  serviceIDsInBasket2: object; //заявка
  accountId: number; //заявка
  companyId: number; //заявка
}

export const ServicesBasket = ({
  setServiceIDsInBasket2,
  serviceIDsInBasket2,
  setShowBasket,
  companyId, 
  accountId,
}: IShowFreeDemand) => {
  const [desireDate, setDesireDate] = useState(date2str(new Date).date);
  const [desireTime, setDesireTime] = useState("");
  const [phone, setPhone] = useState(validatePhoneRU(getPhone()).phone||'');
  const [fio, setFio] = useState($user.getState().firstName||"");
  const [comment, setComment] = useState("");
  const [showComment, setShowComment] = useState(false);
  const {services} = useStore($contractorDems)
  // const {intervals} = useStore($desireIntervals)
  const intervals = [
    {id: "1", interval: "с 13 до 17"},
    {id: "2", interval: "с 09 до 12"}
  ]
  const [choosedServices, setChoosedServices] = useState<IContractorService[]>([]);

  const [newOrderLoading, setNewOrderLoading] = useState(false);
  const [newOrderFailMsg, setNewOrderFailMsg] = useState("");
  const [newOrderRes, setNewOrderRes] = useState<IDem[]>([]);

  const history = useHistory()


  useEffect(() => {
    let choosedIDs = Object.keys(serviceIDsInBasket2)
    setChoosedServices(services.filter(s => choosedIDs.indexOf(s.id +'') != -1 ))
    console.log("in basket:", serviceIDsInBasket2)
  }, [serviceIDsInBasket2])


  useEffect(() => {
    // queryDesireIntervals()
    // console.log("COMPANY_ACCOUNT:", companyId, accountId)
  }, [])

  useEffect(() => {
    if(newOrderLoading) return
    if(newOrderFailMsg.length > 0) {
      toast.error(newOrderFailMsg)
      setNewOrderRes([])
      setNewOrderFailMsg("")
      return
    } else if(newOrderRes.length > 0) {
      toast.success("Заказ успешно оформлен")
      setShowBasket(false)
      history.push(pathDemandSubPay)
    } else {
      /*toast.success("Заказ успешно оформлен111")
      setShowBasket(false)
      history.push(pathDemandSubPay)*/
    }
  }, [newOrderLoading])

  const delServ = (id: string) => {
    let tmp = Object.assign({}, serviceIDsInBasket2)
    //@ts-ignore
    delete tmp[id]
    setServiceIDsInBasket2(tmp)
  }

  const setServ = (id: string, count: number) => {
    let tmp = Object.assign({}, serviceIDsInBasket2)
    //@ts-ignore
    tmp[id] = count
    setServiceIDsInBasket2(tmp)
  }


  const onPhoneChanged = (value: string) => {
    let validated = validatePhoneRU(phone)
    setPhone(validated.ok ? validated.phone : value)
  }
  const onSendClaimClicked = () => {
    let phoneValid = validatePhoneRU(phone)
    let keys = Object.keys(serviceIDsInBasket2)
    let errMsg = ""
    let dems: object[]
    
    if(empty(desireTime)) errMsg = "Желаемое время выполнения заявки не может быть пустым"
    else if(!phoneValid.ok) errMsg = "Введите телефон в формате +7(ХХХ)ХХХ-ХХ-ХХ"
    else if(showComment && empty(comment)) errMsg = "Текст комментария не может быть пустым"
    else if(keys.length == 0)  errMsg = "Не выбраны услуги"
    else {
      dems = collectDemands2send()
      console.log("collected_demands=>", dems.length != keys.length,  dems)
      if(dems.length != keys.length) {
        errMsg = "Возникла проблема при сборе информации о выбранных услугах. Попробуйте перезагрузить страницу."
      }
    }
    if(!empty(errMsg)){
      toast.error(errMsg)
      return
    } else {
      let send = {}
      //@ts-ignore
      send["fio"] = fio
      //@ts-ignore
      send["phone"] = phoneValid.phone
      //@ts-ignore
      send["uuid"] = getUuid()
      //@ts-ignore
      send["session"] = getSession()
      //@ts-ignore
      send["accountId"] = accountId
      //@ts-ignore
      send["companyId"] = companyId
      //@ts-ignore
      send["demands"] = dems
      console.log("TO_SEND:", send)
      queryNewOrder({data: send, setLoading: setNewOrderLoading, setFailMsg: setNewOrderFailMsg, setDems: setNewOrderRes})
    }
  }

  const collectDemands2send = () => {
    let servKeys = Object.keys(serviceIDsInBasket2) 
    let ret: object[] = [];
    console.log("choosed_srvices=====>",  serviceIDsInBasket2)
    for(let i = 0, len = servKeys.length; i < len; ++i) {
      //@ts-ignore
      console.log("ret=>",  empty(servKeys[i]) , empty(serviceIDsInBasket2[servKeys[i]]) , serviceIDsInBasket2[servKeys[i]])
      //@ts-ignore
      if(empty(servKeys[i]) || empty(serviceIDsInBasket2[servKeys[i]]) || serviceIDsInBasket2[servKeys[i]] < 1) continue
      //@ts-ignore
      let serv = services.find(s => s.id == servKeys[i])
      console.log("serv=>",  serv)
      if (serv == undefined) continue
      //@ts-ignore
      let tmp: object = {
         //@ts-ignore
        qty: serviceIDsInBasket2[servKeys[i]],
        contractorDemandId: servKeys[i],
        desireTimeInterval: desireTime,
        desireDateInterval: desireDate,
        demandGroupId: serv.demandGroupId,
        comments: comment
      }
      ret.push(tmp)
    }
    return ret
  }
  //console.log("choosed_srvices:", serviceIDsInBasket2)

  return (
    <>
      <div className="omodal">
        <div className="omodal-content" style={{ background: "#F0F2F5", borderRadius: "12px" }} id="omodalContent" >
          <div className="row col-12 sb_title_con" >
            <div className="sb_title">
              В корзине {choosedServices.length} {endWordOfBasketTitle(choosedServices.length)}
            </div>
            <div className="ml-auto">
              <Button onClick={() => setShowBasket(false)} variant="default" className="sb_btn_close" >
                <Plus style={{ transform: "rotate(45deg)", width: "100%", height: "100%" }} />
              </Button>
            </div>
          </div> 
          <span className="sb_notice">
            Примечание от УК:<br/>- УК не несет ответственности<br/> за предоставленые вами запчастей для ремонта.
          </span>
          <div className="wrap d-flex justify-content-center" style={{ marginBottom: "20px" }}>
            <div className="mr-2"><Form.Control value={desireDate} onChange={e => setDesireDate(e.target.value)} type="date" title="Желаемая дата выполенения заявки" className="sb_elems_shadow_and_border_rad" /></div>
            <div>
              <Form.Control value={desireTime} onChange={e => setDesireTime(e.target.value)} type="tex" title="Желаемое время выполенения заявки" placeholder="Желаемое время выполенения заявки"  className="sb_elems_shadow_and_border_rad" list="desireIntervals"/>
              <datalist id="desireIntervals">
                {intervals.map((di, i) => (
                  <option key={i} value={di.interval} ></option>
                ))}
              </datalist>
            </div>
          </div>
          <div style={{ marginBottom: "24px" }}>
            <Form.Control value={phone} onChange={e => onPhoneChanged(e.target.value)} placeholder={"Введите телефон"} type="tex" title="Телефон для связи" className="sb_elems_shadow_and_border_rad"/>
          </div>
          <div style={{ marginBottom: "24px" }}>
            <Form.Control value={fio} onChange={e => setFio(e.target.value)} placeholder={"Введите ФИО"} type="tex" title="ФИО" className="sb_elems_shadow_and_border_rad"/>
          </div>
          {choosedServices.map((s,i) => (
            <div key={i} className="row col-12 sb_servs_item_main_con">
              <div className="row col-12 m-auto pt-2 pl-2 pr-2 ">
                <span className="col mr-auto" style={{fontWeight: 700, color: "#3D4652"}}>{s.name}</span>
                <div className="ml-auto">
                  <Button onClick={() => delServ(s.id+'')} title="Удалить из корзины" variant="default" className="ml-auto pt-0"><Trash className="text-danger"/></Button>
                </div>
              </div>
              <div className="row col-12 m-auto p-2">
                <span className="col mr-auto mt-auto mb-auto" style={{fontWeight: 900}}>{
                //@ts-ignore
                kopecks2rubStr(s.price ? s.price * serviceIDsInBasket2[s.id+'']: 0)}</span><div className="ml-auto" style={{paddingRight: "0.5rem"}}><ServiceCounter count={serviceIDsInBasket2[s.id+''] == undefined ? "un" : serviceIDsInBasket2[s.id+'']} setServiceIDsInBasket2={setServiceIDsInBasket2} sid={s.id} /></div>
              </div>
              {empty(s.contractors_name) ? <></>: 
              <div className="row col-12 sb_servs_item_provider_con">
                <span className="col mr-auto" >Поставщик: {s.contractors_name}</span>
              </div>}
            </div>
          ))}
          <Button onClick={() => setShowComment(!showComment)} variant="link" className="sb_btn_show_comment">
            {showComment ? "Не оставлять комментарий" : "Оставить комментарий" } 
          </Button>
          <div hidden={!showComment} style={{ marginBottom: "20px",}} >
            <FormControl value={comment} onChange={e => setComment(e.target.value)} placeholder={"Введите комментарий к заказу..."} title="Комментарий к заказу" className="sb_elems_shadow_and_border_rad" as="textarea" />
          </div>
          <div className="m-auto">
          <Button disabled={newOrderLoading} onClick={onSendClaimClicked} variant="default" style={{ background: $SiteColors.getState().backBtnSubmit}} className="sb_btn_submit_order" >
            {newOrderLoading ? <>Оформляем заказ<Spinner className="ml-2" size="sm" animation="border" variant="default"/></>: "Оформить заказ"}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
